import { useCallback } from 'react';
import { useInsightsPanelContext } from '@/components/loop-dashboard/widgets/shared/InsightsPanelContext';
import {
  type OriginActionValueType,
  OriginPage,
  OriginView,
  workItemUpdated,
} from '@/lib/analytics/Avo';

export const useTrackWorkItemUpdated = () => {
  const context = useInsightsPanelContext();

  const track = useCallback(
    (originAction: OriginActionValueType) => {
      workItemUpdated({
        originAction,
        originPage: OriginPage.INSIGHTS_DASHBOARD,
        panelName: context?.panelName ?? null,
        originView: context?.originView ?? OriginView.ITEM_DETAILS_PANEL,
      });
    },
    [context?.panelName, context?.originView],
  );

  return track;
};
